import { API_URL, createRequestActionTypes } from "../../../actions/index";
export const READ_MANY_ASSIGNMENTS_URL = `${API_URL}/api/v1/assignments`;
export const CREATE_PAYOUT_URL = `${API_URL}/api/v1/user/createPayout`;
export const dashboardActionTypes = {
  getCampaigns: createRequestActionTypes("GET_CAMPAIGNS"),
  createInstantPayout: createRequestActionTypes("CREATE_INSTANT_PAYOUT"),
  clearErrorMessages: createRequestActionTypes("CLEAR_DASHBOARD_ERROR_MSG"),
  clearSuccessMessages: createRequestActionTypes("CLEAR_DASHBOARD_SUCCESS_MSG"),
};
